/**
 * Format an epoch-second time as HH:MM in US Eastern (24h). Used for both the
 * time-axis tick labels and the crosshair readout. This audience is US-market
 * only, so the locale is always en-US ET.
 */
export function formatEtTime(epochSec: number): string {
  return new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(new Date(epochSec * 1000));
}
